/**
 * usePutIaAttestations — PUT /v1/clinics/{clinic_id}/improvement-activities
 *
 * Replace-all semantics (handoff §2): the whole IA attestation list is sent
 * on every save; the server deletes old rows and inserts the new ones.
 * Matches the bulk-save modal UX in the IA Score Card edit modal.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getApiClient } from "@/api/client";
import type { IaAttestationRequest, IaAttestationResponse } from "@/api/models";
import { queryKeys } from "./queryKeys";

export function usePutIaAttestations(clinicId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: IaAttestationRequest): Promise<IaAttestationResponse> => {
      const { data } = await getApiClient().put<IaAttestationResponse>(
        `/v1/clinics/${clinicId}/improvement-activities`,
        body,
      );
      return data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.dashboard.byClinic(clinicId) });
    },
  });
}
